import { render, staticRenderFns } from "./TasksListFilter.vue?vue&type=template&id=806faf64&"
import script from "./TasksListFilter.vue?vue&type=script&lang=js&"
export * from "./TasksListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports